import { render, staticRenderFns } from "./ContentText.vue?vue&type=template&id=780f1f5e&"
import script from "./ContentText.vue?vue&type=script&lang=js&"
export * from "./ContentText.vue?vue&type=script&lang=js&"
import style0 from "./ContentText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780f1f5e')) {
      api.createRecord('780f1f5e', component.options)
    } else {
      api.reload('780f1f5e', component.options)
    }
    module.hot.accept("./ContentText.vue?vue&type=template&id=780f1f5e&", function () {
      api.rerender('780f1f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/ContentText.vue"
export default component.exports